import script from "./applyComplaintDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./applyComplaintDialog.vue?vue&type=script&setup=true&lang=js"

import "./applyComplaintDialog.vue?vue&type=style&index=0&id=ff376c4e&lang=scss"
import "./applyComplaintDialog.vue?vue&type=style&index=1&id=ff376c4e&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff376c4e"]])

export default __exports__